import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { DownloadIcon } from 'lucide-react'
import { PropsWithChildren } from 'react'

interface DocumentPreviewDialogProps {
  // Same-origin URL that streams the document content.
  contentUrl: string
  title?: string
}

// Previews a document inline in a dialog by embedding its content URL.
// `children` is the dialog trigger.
export function DocumentPreviewDialog({
  contentUrl,
  title = 'Preview Document',
  children,
}: PropsWithChildren<DocumentPreviewDialogProps>) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="flex flex-col md:max-w-3xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <iframe
          src={contentUrl}
          title={title}
          className="h-[70vh] w-full rounded-md border"
        />
        <Button asChild variant="outline" className="self-end">
          <a href={`${contentUrl}?download=true`}>
            <DownloadIcon />
            Download
          </a>
        </Button>
      </DialogContent>
    </Dialog>
  )
}
